import { EXAM_PAPER_ITEM_TYPE } from 'Components/Quiz/constant';

export const EXAM_PAPER_TYPE = { QUESTION: 'QUESTION', ARTICLE: 'ARTICLE' };

export const mapGuidedPracticeExamPaperItemsToExamItems = (examPaperItems) => {
  if (
    examPaperItems.filter(
      (item) =>
        item.type === EXAM_PAPER_TYPE.QUESTION &&
        item.questionType !== EXAM_PAPER_ITEM_TYPE.MULTIPLE_CHOICE &&
        item.questionType !== EXAM_PAPER_ITEM_TYPE.MULTIPLE_SELECT
    ).length > 0
  ) {
    throw new Error(
      'This exam contains unsupported question types. Only MULTIPLE_CHOICE and MULTIPLE_SELECT are supported.'
    );
  }
  return examPaperItems.map((examPaperItem) => {
    if (examPaperItem.type === EXAM_PAPER_TYPE.ARTICLE) {
      return {
        id: examPaperItem.id,
        articleId: examPaperItem.articleId,
        title: examPaperItem.title,
        details: examPaperItem.details,
        type: EXAM_PAPER_TYPE.ARTICLE,
        articleType: EXAM_PAPER_TYPE.ARTICLE,
        order: examPaperItem.order,
      };
    }
    if (examPaperItem.type === EXAM_PAPER_TYPE.QUESTION) {
      return {
        id: examPaperItem.id,
        question: examPaperItem.question,
        questionId: examPaperItem.questionId,
        questionType: examPaperItem.questionType,
        choices: examPaperItem.metadataV2.choices.map((choice) => ({
          value: choice.value,
          label: choice.label,
        })),
        correctAnswer: examPaperItem.correctAnswer.value,
        solution: examPaperItem.solution,
        type: EXAM_PAPER_TYPE.QUESTION,
        answer: examPaperItem.answer,
        order: examPaperItem.order,
      };
    }
    throw new Error(`This examPaperItem: ${examPaperItem.id} is not a QUESTION or ARTICLE type`);
  });
};
